export const GetTotalStaffSelector = ({
  yusaOvernightCampStaffData: { getYusaOvernightCampStaff }
}) => getYusaOvernightCampStaff;

export const PostTotalStaffSelector = ({
  yusaOvernightCampStaffData: { postYusaOvernightCampStaff }
}) => postYusaOvernightCampStaff;

export const GetWagesSelector = ({
  yusaOvernightCampStaffData: { getYusaOvernightCampWages }
}) => getYusaOvernightCampWages;
